import React from 'react';
import LineGraph from 'components/Charts/LineGraph';
import { roundValue } from 'modules/Prices/helpers';
import { EvolutionLineChartDiv } from 'modules/Prices/pages/evolution/container';

const EvolutionLineChart = ({
  data = [],
  labels = [],
  currency,
  network
}: {
  data: any[];
  labels: string[];
  currency: string;
  network: string | null;
}) => {
  const renderStrokeLine = (network: string | null) => {
    if (network === 'WEB' || network === 'OFF') {
      return [null, ['5 5'], null, null, null];
    }
    return undefined;
  };

  return (
    <EvolutionLineChartDiv>
      <LineGraph
        data={data}
        tooltipOffset={{
          x: 0,
          y: 40
        }}
        labels={labels}
        strokeDasharray={renderStrokeLine(network)}
        yAxisProps={{
          width: 90,
          type: 'number',
          scale: 'linear',
          interval: 'preserveStartEnd',
          tickFormatter: (value: any) =>
            value.toLocaleString('fr-FR', {
              style: 'currency',
              currency: currency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }),
          domain: [
            (dataMin: any) =>
              isFinite(dataMin) && parseInt(dataMin) - 200 > 0
                ? dataMin - dataMin * 0.5 - 20
                : 0,
            (dataMax: any) => roundValue(dataMax + dataMax * 0.2 + 20, 10)
          ]
        }}
        colors={[
          '#e25d34',
          '#1f2b37',
          '#a5aaaf',
          '#525d69',
          '#C9D0D6',
          '#B1B7BD'
        ]}
      />
    </EvolutionLineChartDiv>
  );
};

export default EvolutionLineChart;
